import React, { useState } from 'react';
import classnames from 'classnames';
import convert from 'htmr';
import IconCaret from '../../files/caret.svg';
import Button from '../Button/Button';
import DatePicker from '../DatePicker/DatePicker';
import transform from '../_utils/convertTransformForms';

const Filters = ({
  heading = 'Filters',
  formAction = '?',
  hasDatePicker = false,
  paramFromName,
  paramToName,
  paramFormat,
  selectedFromDate,
  selectedToDate,
  children,
  proxy,
}) => {
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(false);

  const filterClasses = classnames('side-nav__filters margins-off', {
    active: isFiltersExpanded,
  });

  const filterFormClasses = classnames('filters__form', {
    active: isFiltersExpanded,
  });

  const toggleButtonClasses = classnames('btn filters__toggle', {
    active: isFiltersExpanded,
  });

  const toggleForm = () => setIsFiltersExpanded(!isFiltersExpanded);

  const proxyContent = proxy && proxy.innerHTML && proxy.innerHTML.trim();

  return (
    <div className={filterClasses}>
      <div className="filters__header">
        <button
          className={toggleButtonClasses}
          onClick={toggleForm}
          aria-label="Expand/close filters"
          aria-expanded={isFiltersExpanded}
          aria-controls="filters-form"
        >
          <span>{heading}</span>
          <IconCaret focusable={false} width="12" height="7" />
        </button>
      </div>
      <form id="filters-form" action={formAction} className={filterFormClasses}>
        {hasDatePicker && (
          <DatePicker
            paramFromName={paramFromName}
            paramToName={paramToName}
            paramFormat={paramFormat}
            selectedFromDate={selectedFromDate}
            selectedToDate={selectedToDate}
            isClearable={true}
          />
        )}
        {proxyContent ? convert(proxyContent, { transform }) : children}
        <div className="filters__cta">
          <Button type="submit" text="Apply filters" />
        </div>
      </form>
    </div>
  );
};

export default Filters;
